export function pad(number: number) {
    if (number >= 10) {
        return String(number);
    }

    return `0${number}`;
}

export function convert(inputYear: number, inputMonth: number) {
    if (inputMonth <= 0 || inputMonth > 12) {
        throw new TypeError(`Invalid month: ${inputMonth}`);
    }

    const yearAsString = String(inputYear);
    const monthAsString = pad(inputMonth);

    return {
        year: yearAsString,
        month: monthAsString,
        nextMonth: inputMonth === 12 ? 1 : inputMonth + 1,
        nextYear: inputMonth === 12 ? inputYear + 1 : inputYear
    };
}

export function asDate(inputYear: number, inputMonth: number, inputDay: number) {
    return `${inputYear}-${pad(inputMonth)}-${pad(inputDay)}`;
}
